<script setup lang="ts">
import {onMounted, watchEffect} from 'vue'
import {storeToRefs} from 'pinia'
import {useRouter} from 'vue-router'
import {Button} from '@/components/ui/button'
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from '@/components/ui/card'
import {Skeleton} from '@/components/ui/skeleton'
import {useUserStore} from '@/stores/user'
import {useDashboardStore} from '@/stores/dashboard'
import HomeDashboard from '@/components/dashboard/HomeDashboard.vue'

const router = useRouter()
const userStore = useUserStore()
const dashboardStore = useDashboardStore()
const {user, profile} = storeToRefs(userStore)
const {data: dashboard, isLoading} = storeToRefs(dashboardStore)

onMounted(() => {
  if (!user.value) {
    router.push('/auth')
  }
})

watchEffect(() => {
  if (!profile.value) return
  dashboardStore.fetchDashboard(profile.value.profile_id)
})
</script>

<template>
  <Teleport defer to="#app-header-left">
    <h1 class="text-sm font-medium">{{ $t('home.title') }}</h1>
  </Teleport>

  <div v-if="profile && dashboard?.eligible" class="w-full">
    <HomeDashboard :data="dashboard" />
  </div>

  <div v-else-if="isLoading" class="mx-auto flex w-full max-w-3xl flex-col gap-3 px-6 py-8">
    <Skeleton class="h-8 w-56" />
    <div class="grid grid-cols-2 gap-3 xl:grid-cols-4">
      <Skeleton v-for="i in 4" :key="i" class="h-24" />
    </div>
    <Skeleton class="h-72 w-full" />
  </div>

  <div v-else class="mx-auto flex min-h-[calc(100dvh-3rem)] w-full max-w-3xl flex-col justify-center px-6 py-8">
    <Card>
      <CardHeader>
        <CardTitle>{{ $t('home.title') }}</CardTitle>
        <CardDescription>{{ $t('home.description') }}</CardDescription>
      </CardHeader>
      <CardContent v-if="!profile" class="flex flex-col items-start gap-2">
        <p class="text-sm text-muted-foreground">{{ $t('profile.emptyDescription') }}</p>
        <Button @click="router.push('/user')">{{ $t('profile.create') }}</Button>
      </CardContent>
    </Card>
  </div>
</template>
